import * as React from 'react';

import { GlyphName } from '@remind/r101-glyphs';
import AdminNoticeBanner from 'admin/components/AdminNoticeBanner';
import Button from 'components/ButtonDeprecated';
import { GlyphColor } from 'components/Glyph';
import Icon from 'components/Icon';
import Link from 'components/Link';
import Text from 'components/Text';
import EventTracking from 'lib/EventTracking';

type Props = {
  errors: number;
  alerts: number;
  csvUrl?: string;
  orgUuid: string;
};

const AdminSchoolSisDashboardSummary = (props: Props) => {
  const { errors, alerts, csvUrl, orgUuid } = props;
  const handleLinkClicked = () => {
    EventTracking.track('rostering.errors.downloaded.all', {
      organization_uuid: orgUuid,
    });
  };

  const actionElement = () => {
    if (errors + alerts > 0) {
      return (
        <Button
          aria-label="Download CSV zip file"
          href={csvUrl}
          download
          level="icon"
          size="small"
          target="_blank"
          tooltip="Download CSV zip file"
          tooltipPlacement="left"
          onClick={handleLinkClicked}>
          <Icon name="arrow-down-bar" size="large" />
        </Button>
      );
    }

    return null;
  };

  let next: React.ReactNode = 'Nothing to do!';
  let glyph: GlyphName = 'success-checkmark-stroke';
  let color: GlyphColor = 'atlas';

  if (errors) {
    next = (
      <Link href={csvUrl} target="_blank" onClick={handleLinkClicked}>
        Download CSVs and fix
      </Link>
    );
    glyph = 'explanation-circle';
    color = 'apple';
  } else if (alerts) {
    next = 'Fix your alerts';
    glyph = 'caution';
    color = 'pencil';
  }

  return (
    <AdminNoticeBanner glyph={glyph} color={color} actionElement={actionElement()}>
      <Text element="div">
        Total errors: <Text weight="semibold">{errors}</Text>
      </Text>
      <Text element="div">
        Total alerts: <Text weight="semibold">{alerts}</Text>
      </Text>
      <Text element="div">
        Next step: <Text weight="semibold">{next}</Text>
      </Text>
    </AdminNoticeBanner>
  );
};

export default AdminSchoolSisDashboardSummary;
